import React from 'react';

import CommonImage from '@components/CommonImage';

const SortingDropdown = ({ onSelectOption, selectedOption, sortingOptions }) => {
	return (
		<div className="option">
			<div className="dropdown">
				<button
					className="btn btn-default dropdown-toggle d-flex align-items-center"
					style={{ gap: '10px' }}
					type="button"
					id={`menu`}
					data-toggle="dropdown"
					aria-expanded="false"
				>
					<p className="regular-14 ">{selectedOption}</p>
					<CommonImage src="/images/chevron_down.svg" alt="chevron_down" />
				</button>
				<ul
					className="dropdown-menu dropdown-menu-right shadow-4dp"
					role="menu"
					aria-labelledby={`menu`}
					x-placement="top-end"
				>
					{sortingOptions.map((item) => (
						<li
							key={item?.code}
							role="presentation"
							className={`px-4 pb-3 pt-3 ${selectedOption === item?.title ? 'active' : ''}`}
							onClick={() => {
								onSelectOption(item);
								window.scrollTo(0, 0);
							}}
						>
							<span className="font-weight-normal  text-black" key={item?.code}>
								{item?.title}{' '}
							</span>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default SortingDropdown;
